import { useState } from 'react';
import { DataPolicyProps, getDataPolicy } from '../../../services/DataPolicyService';

export const useDataPolicy = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataPolicy, setDataPolicy] = useState<DataPolicyProps>({ title: '', renderedView: '' });

  //@ts-ignore
  const isAdmin = window.isAdminPage;

  // adatkezelési szabályzat megnyitása modalban
  const openDataPolicy = async () => {
    // Ha admin oldalon vagyunk, akkor return
    if (isAdmin) return;

    try {
      const response = await getDataPolicy();
      setDataPolicy(response);
      setIsModalOpen(true);
    } catch (error) {
      throw new Error(error);
    }
  };

  // winegroup adatkezelési szabályzat megnyitása új tabon
  const openWinegroupDataPolicy = () => {
    // Ha admin oldalon vagyunk, akkor return
    if (isAdmin) return;
    window.open('https://winegroup.hu/adatkezelesi-tajekozato/', '_blank');
  };

  return { isModalOpen, setIsModalOpen, dataPolicy, openDataPolicy, openWinegroupDataPolicy };
};
